import type { DeliveryAddressModel, DeliveryAddressReqModel } from '@develop/ia-api-library'

export type DeliveryFormOption = 'deliveryByAgreement' | 'homeDelivery' | 'expressDelivery' | 'pickup'
export enum DeliveryOption {
  DeliveryByAgreement = 'deliveryByAgreement',
  HomeDelivery = 'homeDelivery',
  ExpressDelivery = 'expressDelivery',
  Pickup = 'pickup',
}

export type CheckoutDeliveryModelV2 = {
  address: DeliveryAddressModel | DeliveryAddressReqModel | null
  deliveryType: DeliveryFormOption | null
  deliveryPeriod?: {
    extended: string
    short: string
    id: number
  }
}
